import { useEffect } from 'react';

import useBranchId from '@maya/hooks/useBranchId';
import useTranslate from '@maya/hooks/useTranslate';
import { useAppDispatch, useAppSelector } from '@maya/store/hooks';
import { loadPatients, selectPatients } from '@maya/store/slices/patient';

export default function usePatients(search: string) {
  const branchId = useBranchId();
  const t = useTranslate();

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!branchId) {
      return;
    }

    dispatch(loadPatients({ branchId, search }, t));
  }, [branchId, dispatch, search, t]);

  return useAppSelector(selectPatients);
}
